// INFO:工单最外层的 hooks 方便子集自我调用.这里不要放在方法内部的闭包，要做持久化统一处理
// NOTE:避免穿透接收找不到溯源，以及多次inject重复命名
// 处理工单的时候需要判断当前的登录状态
import { createVNode, ref } from 'vue'
import { Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { getToken, TokenKey } from '@/utils/auth'
import { UserInfo } from '@/api/login'
import store from '@/store/index'
import { clearStoreChatMsgList } from '@/utils/unReadNum'
import useTopUp from '@/hooks/useTopUp'
import { REFRESH_LIST } from '@/views/WorkPlace/handleEventBuss'
const { recoverTopList } = useTopUp()
// 初始无数据时显示 empty
export const isEmpty = ref(true)
export const loading = ref(false)

// NOTE:初始化所有属性。完成会话显示 缺省页
export const initWorkOrder = (refresh = true) => {
  isEmpty.value = true
  recoverTopList()
  // FIXME:清除当前会话和查询会话的id
  store.commit('workOrder/SET_CHART_ID')
  // FIXME:清除当前聊天的所有消息
  store.commit('workOrder/SET_GROUP_INFO')
  // FIXME:清空当前会话内容
  store.commit('updateCurrentMsgList', [])
  // 清空当前 groupId
  store.commit('group/SET_DEALING_GROUPID')
  // FIXME:完成会话后重新查询列表
  REFRESH_LIST?.emit()
}
// 获取个人状态判断坐班状态
export const handleWorkStatus = () => {
  return new Promise((resolve, reject) => {
    UserInfo({ [TokenKey]: getToken() })
      .then(res => {
        const { shiftStatus } = res
        store.commit('user/SET_WORK_STATUS', shiftStatus)
        store.commit('user/SET_USER_INFO', res)
        if (shiftStatus === 1) {
          Modal.confirm({
            title: () => '当前为休息状态',
            icon: () => createVNode(ExclamationCircleOutlined),
            content: () => '休息状态时无法处理待办，请切换至坐班状态',
            okText: '切换',
            onOk() {
              store.dispatch('user/handleChangeWorkStatus', {
                status: 0
              })
              store.commit('initChatState')
              clearStoreChatMsgList()
              initWorkOrder()
            },
            onCancel() {
              console.log('Cancel')
            }
          })
          reject()
        } else {
          resolve()
        }
      })
      .catch(() => {
        reject()
      })
  })
}
